"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asLanguage = exports.isLanguage = exports.defaultLanguage = exports.Language = exports.languages = void 0;
var typebox_1 = require("@sinclair/typebox");
exports.languages = [
    "en",
    "en-GB",
    "fr",
    "de",
    "es",
    "pt",
    "it",
    "ru",
    "ja",
    "zh",
];
exports.Language = typebox_1.Type.Union(exports.languages.map(function (lang) { return typebox_1.Type.Literal(lang); }), {
    title: "Language",
});
exports.defaultLanguage = "en";
var isLanguage = function (x) {
    switch (x) {
        case "de":
        case "en":
        case "en-GB":
        case "es":
        case "fr":
        case "it":
        case "ja":
        case "pt":
        case "ru":
        case "zh":
            return true;
        default:
            return false;
    }
};
exports.isLanguage = isLanguage;
var asLanguage = function (x) { return (0, exports.isLanguage)(x) ? x : exports.defaultLanguage; };
exports.asLanguage = asLanguage;
